import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCanvases } from '../../../app/store/slices/canvasSlice';
import { useCanvas } from '../context/CanvasContext';
import { selectCurrentPlan } from '../../../app/store/slices/subscriptionSlice';

const CanvasSwitcher = ({ onCanvasSwitch }) => {
  const { owned: ownedCanvases = [], shared: sharedCanvases = [] } = useSelector(selectCanvases) || { owned: [], shared: [] };
  const { selectedCanvas, updateSelectedCanvas } = useCanvas();
  
  const allCanvases = [...(Array.isArray(ownedCanvases) ? ownedCanvases : []), 
                       ...(Array.isArray(sharedCanvases) ? sharedCanvases : [])];

  // Effect to set default canvas when component mounts
  useEffect(() => {
    if (!selectedCanvas.id && allCanvases.length > 0) {
      const defaultCanvas = allCanvases[0];
      
      updateSelectedCanvas(defaultCanvas);
      onCanvasSwitch(defaultCanvas._id);
    }
  }, [allCanvases, selectedCanvas.id, updateSelectedCanvas, onCanvasSwitch]);

  return (
    <div className="relative">
      <select
        className="w-full sm:w-auto px-3 py-1.5 bg-btn-primary border border-gray-300 rounded-lg 
          text-sm text-white focus:outline-none focus:ring-btn-secondary appearance-none cursor-pointer"
        onChange={(e) => {
          if (e.target.value) {
            const selectedCanvasObj = allCanvases.find(canvas => canvas._id === e.target.value);
            if (selectedCanvasObj) {
              updateSelectedCanvas(selectedCanvasObj);
              onCanvasSwitch(e.target.value);
            }
            e.target.value = '';
          }
        }}
        value=""
      >
        <option value="">Switch Canvas</option>
        {allCanvases.map((canvas) => (
          <option 
            key={canvas._id} 
            value={canvas._id}
            className="bg-white text-gray-800"
          >
            {canvas.type === 'private' ? '🔒 ' : '👥 '}{canvas.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CanvasSwitcher;